import * as React from "react"
import {StaticImage} from "gatsby-plugin-image"

import logo from "../images/logo.svg"

const Banner = () => (
  <section className="banner">
    <div id="main-slide" className="carousel slide" data-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <StaticImage src="../images/top.jpg" layout="fullWidth" quality={95} formats={["auto", "webp", "avif"]} alt="SRE NEXT" />
          <div className="carousel-caption d-md-block">
            <h1 className="wow fadeInDown heading" data-wow-delay=".4s">
              <img src={logo} alt="SRE NEXT" />
              <span className="d-none d-sm-inline">SRE NEXT</span> 2022 ONLINE
            </h1>
            <p className="fadeInUp wow" data-wow-delay=".6s">2022/5/14(Sat), 15(Sun)</p>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default Banner
